@if (!setupPath) {
  <small class="text-muted">{{ 'setupPreview.selectConfiguration' | translate }}</small>
} @else if (loading) {
  <small class="text-muted">{{ 'setupPreview.loading' | translate }}</small>
} @else if (angles.length === 0) {
  <small class="text-muted">{{ 'setupPreview.unavailable' | translate }}</small>
} @else {
  <div class="setup-preview">
    @for (angle of angles; track $index) {
      <figure class="setup-preview-angle" [style.max-width]="maxWidth(angle)">
        @if (hasImage(angle)) {
          <div class="setup-preview-frame" [class.natural-size]="!aspectRatio(angle)" [style.aspect-ratio]="aspectRatio(angle)">
            <img [src]="angle.imgUrl" [alt]="angle.cameraName" loading="lazy" (error)="failedImages.add(angle.imgUrl)" />
            @if (angle.areas.length > 0) {
              <svg [attr.viewBox]="'0 0 ' + angle.width + ' ' + angle.height" preserveAspectRatio="none">
                @for (area of angle.areas; track $index) {
                  <polygon [attr.points]="area.points" [attr.stroke]="area.color" [attr.fill]="area.color"></polygon>
                }
              </svg>
            }
          </div>
        }
        <figcaption class="text-muted">
          <span>{{ angle.cameraName }}</span>
          @if (angle.detectionModeName) {
            <span> · {{ angle.detectionModeName }}</span>
          }
          @if (!hasImage(angle)) {
            <span> — {{ 'setupPreview.noImage' | translate }}</span>
          }
        </figcaption>
      </figure>
    }
  </div>
}
